// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#basket-empty div[data-v-88c54fb8]{margin-top:22vh;margin-bottom:22vh}#basket-empty svg[data-v-88c54fb8]{color:#9b9b9b;width:50%;height:30%}#basket-empty h2[data-v-88c54fb8]{color:#979797}.bg-warning-light[data-v-88c54fb8]{background-color:#ffe9a4}", ""]);
// Exports
module.exports = exports;
